import React from "react";
import ActiveLink from "src/components/layouts/ActiveLink";
import styles from "src/styles/components/elements/paginate.module.scss";

// Pagination Component (max step size 3)
const Pagination = ({ data, urlSlug, href, link }) => {
  const { totalPages, page } = data;
  const finalData = [];
  let size = 3;
  let initial = 1;

  if (page > size) {
    initial = page - (size - 1);
    size = page;
  }
  if (totalPages < size) {
    size = totalPages;
  }
  if (totalPages > 0) {
    for (let i = initial; i <= size; i++) {
      finalData.push(
        <ActiveLink
          activeClassName={styles.select}
          href={href}
          as={link(i === 1 ? `${urlSlug}` : `${urlSlug}?page=${i}`)}
          key={i}
        >
          <span> {i} </span>
        </ActiveLink>
      );
    }
  }
  return finalData;
};

const Paginate = React.memo(({ href, link, mainData, urlSlug }) => {
  const currentPage = mainData.page;
  const prevPageLink =
    currentPage > 2 ? `${urlSlug}?page=${currentPage - 1}` : urlSlug;
  const nextPageLink = `${urlSlug}?page=${currentPage + 1}`;

  return (
    <div className={styles.pagination_wrapper}>
      <div className={styles.pagination}>
        <ActiveLink activeClassName="" href={href} as={link(prevPageLink)}>
          <span
            className={
              mainData.hasPrevPage ? "" : `pointer-none ${styles.disabled}`
            }
          >
            Previous
          </span>
        </ActiveLink>

        <Pagination data={mainData} urlSlug={urlSlug} href={href} link={link} />

        <ActiveLink activeClassName="" href={href} as={link(nextPageLink)}>
          <span
            className={
              mainData.hasNextPage ? "" : `pointer-none ${styles.disabled}`
            }
          >
            Next
          </span>
        </ActiveLink>
      </div>
    </div>
  );
});

Paginate.displayName = "Paginate";

export default Paginate;
